<template>
	<keep-alive>
		<router-view />
	</keep-alive>


</template>

<script>
	/** 教师所有页面包含当前页面 */
	export default {
		data() {
			return {
				courseware: {} //当前课程
			}
		},
		mounted() {
			// console.log('teacher.vue');
		},
		beforeDestroy() {
			console.log('beforeDestroy.vue');
		}
	}

</script>
<style>
	@import url('../../static/css/teacherCommon.css');
	/* @import url('../../static/css/vueWeui.min.css');
	@import url('../../static/css/switch.css'); */
</style>



// WEBPACK FOOTER //
// src/frame/teacher.vue